import { BaseCliJsStepAction } from './baseCliJsStepAction';

export class CliJsStepAction extends BaseCliJsStepAction {
    protected isFailedResult(resultValue: any) {
        return resultValue === false;
    }
}
